<app-tab>
  <div>
    <h2 style="padding: 16px; font-size: 24px; font-weight: bold; margin-bottom: 16px;">Paramètres</h2>
    
    <!-- Manual Reconstruction Section -->
    <div *ngIf="canGenerate" class="p-3 mb-3 bg-gray-50 border rounded flex items-center justify-between">
      <div class="flex items-center space-x-4">
        <span class="text-sm font-medium text-gray-700">Reconstruction manuelle:</span>
        <dx-date-box
          [(value)]="reconstructDate"
          width="140"
          stylingMode="outlined"
          placeholder="Sélectionner une date">
        </dx-date-box>
        <dx-button
          text="Lancer la reconstruction"
          icon="refresh"
          type="default"
          (onClick)="reconstruct()">
        </dx-button>
      </div>
      <span class="text-xs text-gray-500">Génère les interventions reconstruites pour la date sélectionnée</span>
    </div>

    <div *ngIf="!canGenerate" style="padding: 16px; background-color: #fef3c7; border: 1px solid #fde68a; border-radius: 4px; margin: 16px;">
      <p style="font-size: 14px; color: #92400e;">Vous n'avez pas la permission de lancer une reconstruction manuelle.</p>
    </div>
  </div>
</app-tab>

